import { render, staticRenderFns } from "./SiteDashboard.vue?vue&type=template&id=8204ffd8"
import script from "./SiteDashboard.vue?vue&type=script&lang=js"
export * from "./SiteDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports